import React from 'react'
import { Button } from 'evergreen-ui'
import { IoNewspaper } from 'react-icons/io5'
import { PrintRegist } from '../../../Components/AllowPermission'

const StatusManageRegist_1 = ({ DataRegister }) => {
  return (
    <></>
    // <Button
    //   disabled={PrintRegist(DataRegister[0].ROB_ID, DataRegister[0].Major1_MAJOR_ID, DataRegister)}
    //   iconBefore={<IoNewspaper />}
    //   appearance="primary"
    //   intent="success"
    //   onClick={() => {
    //     DataRegister[0].Major1_MAJOR_ID === "9902"
    //       ? window.open(
    //         "https://admission.kpru.ac.th/admission2017/dashboard_printregistrar2018_nurse?code_test=" +
    //         DataRegister[0].REGISTER_ID
    //       )
    //       : window.open(
    //         "https://admission.kpru.ac.th/admission2017/dashboard_printregistrar2022?code_test=" +
    //         DataRegister[0].REGISTER_ID
    //         //6411207001คือรหัสประจำตัวผู้สมัคร
    //       );
    //   }}
    // >
    //   พิมพ์ใบสมัคร
    // </Button>
  )
}

export default StatusManageRegist_1